import { Model } from '../core/base.model';

export class BenefitType extends Model {
    protected static _resource = 'benefitManagement/benefitTypes';

    protected static _version = 'v2';

    get name(): string {
        return this._attributes['name'];
    }
}
